/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */
import React, { useEffect } from "react";
import { Header, PreLoading } from "@tripian/react";
import Model from "@tripian/model";
import useFavorite from "../../hooks/useFavorite";
import useTranslate from "../../hooks/useTranslate";
import PoiCard from "../../components/PoiCard/PoiCard";
import IFavoritePoi from "../../models/IFavoritePoi";
import AppNav from "../../App/AppNav/AppNav";
import { FAVORITES_PAGE, PLACE_INFO } from "../../constants/ROUTER_PATH_TITLE";

const FavoritesPage = () => {
  const {
    cityId,
    favorites,
    favoriteAdd,
    favoriteDelete,
    loadingFavorites,
    loadingFavoritePoi,
    favoritesFetch,
  } = useFavorite();

  const { t } = useTranslate();

  document.title = FAVORITES_PAGE.TITLE(
    t("trips.myTrips.itinerary.favorites.title")
  );

  useEffect(() => {
    if (favorites === undefined && loadingFavorites === false) favoritesFetch();
  }, [cityId, favorites, favoritesFetch, loadingFavorites]);

  // Favorilerde olup olmadığını kontrol eden fonksiyon
  const isFavorite = (poiId: string) =>
    favorites
      ? favorites.findIndex(favorite => favorite.poiId === poiId) > -1
      : false;

  // Favorilere ekle/çıkar fonksiyonu
  const favoriteToggle = (poi: Model.Poi, add: boolean) => {
    if (add) {
      favoriteAdd(poi.id);
    } else {
      const favoriteId: number =
        favorites?.find(favorite => favorite.poiId === poi.id)?.id || 0;
      if (favoriteId) favoriteDelete(favoriteId, poi.id);
      else
        console.error(
          "favoriteToggle favorite delete error: Can not found poi id in favorite list",
          add,
          poi.id,
          favorites
        );
    }
  };

  const renderContent = () => {
    if (favorites) {
      if (favorites.length === 0)
        return (
          <div className="center mt-8">
            <span>
              {t("trips.myTrips.itinerary.favorites.emptyMessage")}
            </span>{" "}
          </div>
        );

      return favorites.map((favoritePoi: IFavoritePoi) =>
        loadingFavoritePoi(favoritePoi.poiId) ? (
          <div
            key={`favorite-loading-${favoritePoi.id}`}
            className="mt-16 mb-16"
          >
            <PreLoading size="small" />
          </div>
        ) : (
          <PoiCard
            key={`favorite-poi-ref-card-${favoritePoi.id}`}
            poi={favoritePoi.poi}
            inStep={false}
            isFavorite={isFavorite(favoritePoi.poi.id)}
            isLoadingFavorite={loadingFavoritePoi(favoritePoi.poi.id)}
            TOUR_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
            TICKET_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
            RESTAURANT_RESERVATION_PROVIDER_IDS={
              window.tconfig.RESTAURANT_RESERVATION_PROVIDER_IDS
            }
            hideTourTicketIcons
            hideActionButtons
            gygTourIds={[]}
            bbTourIds={[]}
            viatorTourIds={[]}
            toristyTourIds={[]}
            tourTicketProductsLoading={false}
            poiCardClicked={() =>
              window.open(`${PLACE_INFO.PATH}/${favoritePoi.poi.id}`, "_blank")
            }
            onAddPoiClick={() => {}}
            onFavoriteToggle={favoriteToggle}
            onBookingClick={() => {}}
            t={t}
          />
        )
      );
    }

    return null;
  };

  return (
    <div className="w-full">
      <AppNav
        header={FAVORITES_PAGE.HEADER?.(
          t("trips.myTrips.itinerary.favorites.title")
        )}
      />
      <div className="container pt8 w-[90%] md:w-[60%]">
        {/* <div className="row mb0 mt0">
          <div className="col col12 pl0">
            <BackButton text={t("trips.cloneTrip.back")} clicked={() => {}} />
          </div>
        </div> */}
        <div className="row mb0">
          <div className="col col12 p0">
            <Header text={t("trips.myTrips.itinerary.favorites.title")} />
          </div>
        </div>
        {loadingFavorites && favorites === undefined ? (
          <div className="flex w-full items-center justify-center h-[calc(100vh-64px)]">
            <PreLoading />
          </div>
        ) : (
          <div className="row">
            <div className="mt5">{renderContent()}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
